import {Image} from '@/_application/core/components/ui/image';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {getBrandUrl} from '@/_application/core/utils/common';
import {compareBrandByPosition} from '@/_application/modules/brand/helpers/brand-data';
import {AggregationOption, HighlightBrand, HighlightBrands} from '__generated__/__types__';
import Link from 'next/link';
import React, {useMemo} from 'react';
import {Scrollbar} from 'swiper/modules';

interface ProductCategorySpotlightBrandProps {
    options: AggregationOption[];
    highlightBrands?: HighlightBrands | null;
}

const ProductCategorySpotlightBrand: React.FC<ProductCategorySpotlightBrandProps> = ({options, highlightBrands}) => {
    const brands = useMemo(() => {
        const allBrands = highlightBrands?.items ?? [];

        const filteredBrands = (options
            ?.filter(option => option)
            ?.map(option => {
                const matchingBrand = allBrands?.find(brand => brand?.label === option?.value);
                return matchingBrand;
            })
            ?.filter(brand => brand) ?? []) as HighlightBrand[];

        return filteredBrands.sort(compareBrandByPosition);
    }, [options, highlightBrands]);

    if (!brands.length) {
        return null;
    }

    return (
        <div className="mb-10">
            <Swiper
                direction="horizontal"
                scrollbar={{
                    el: '.swiper-scrollbar',
                    draggable: true,
                    dragSize: 'auto',
                }}
                modules={[Scrollbar]}
                breakpoints={{
                    1280: {
                        slidesPerView: 7.55,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 5.5,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 4.5,
                        spaceBetween: 10,
                    },
                }}
                className="pb-8!">
                {brands?.map(brand => {
                    const image = brand?.img;
                    if (!image || !brand?.url) return <></>;
                    const brandUrl = getBrandUrl(brand.url);

                    return (
                        <SwiperSlide key={brand?.id}>
                            <Link
                                href={brandUrl}
                                className="flex h-[100px] w-[100px] select-none items-center justify-center overflow-hidden rounded-[170px] border border-solid border-KPZ_turquoise transition-opacity hover:opacity-80 lg:h-[120px] lg:w-[120px]">
                                <div className="flex h-[80px] w-[80px] items-center justify-center p-2.5">
                                    <Image src={image} alt={brand?.label ?? 'Logo'} width={100} height={100} />
                                </div>
                            </Link>
                        </SwiperSlide>
                    );
                })}

                <div className="swiper-scrollbar"></div>
            </Swiper>
        </div>
    );
};

export default ProductCategorySpotlightBrand;
